import { useTranslation } from 'react-i18next';
import {
  SectionWrapper,
  StyledHr,
  ContentWrapper,
  TextBox2,
  SectionContainer,
} from './AuditTwo.style';

const AuditTwo = () => {
  const { t } = useTranslation('audit');
  return (
    <SectionContainer>
      <SectionWrapper>
        <h1>{t('auditTwo.title')}</h1>
        <StyledHr />
      </SectionWrapper>

      <ContentWrapper>
        <TextBox2>
          <div className="grid-content">
            <h2>{t('auditTwo.subtitleOne')}</h2>
            <p>{t('auditTwo.paragraphOne')}</p>
          </div>
          <div className="grid-content">
            <h2>{t('auditTwo.subtitleTwo')}</h2>
            <p>{t('auditTwo.paragraphTwo')}</p>
          </div>
          <div className="grid-content">
            <h2>{t('auditTwo.subtitleThree')}</h2>
            <p>{t('auditTwo.paragraphThree')}</p>
          </div>
        </TextBox2>
      </ContentWrapper>
    </SectionContainer>
  );
};

export default AuditTwo;
